angular
    .module("newRequest.components", [])
    .component("newRequest", {
        templateUrl: "ng/components/newRequest/newRequest.view.html",
        controllerAs: "newRequestCtrl",
        bindings: {
            startRequestPractice: "&"
        },
        controller: function (
            $arcService,
            $location,
            $rootScope,
            RichiestePostVendita,
            $transactionFactory,
            $timeout
        ) {
            var self = this;

            self.$onInit = function () {
                self.supportModel = {
                    listaCategorie: undefined,
                    listaTipoRichiesta: undefined,
                    contrattiSelezionati: undefined,
                    tipoRichiestaSelezionata: undefined,
                    message: undefined,
                    additionalInfo: false,
                    creaRichiestaEnabled: false,
                    isPending: false,
                    listaContratti: [],
                    elementSelected: [],
                    isSpesa: false,
                    checkSpesa: {
                        selected: false
                    }
                }
                getListOfContract();
            }

            self.handleChange = function (property, value) {
                switch (property) {
                    case 'categoria':
                        self.supportModel.listaTipoRichiesta = undefined;
                        self.supportModel.tipoRichiestaSelezionata = undefined;
                        self.supportModel.additionalInfo = false;
                        self.getDropDownRequestsPv();
                        break;
                    case 'tipoRichiesta':
                        self.supportModel.listaTipoRichiesta.forEach(function (tipo) {
                            if (tipo.subtypeDescr == value) {
                                self.supportModel.tipoRichiestaSelezionata = tipo
                            }
                        })
                        self.supportModel.additionalInfo = !self.supportModel.tipoRichiestaSelezionata.hasWizard ? true : false;
                        self.supportModel.isSpesa = self.supportModel.tipoRichiestaSelezionata.spesa ? true : false;
                        self.supportModel.checkSpesa.selected = false;
                        disabledNotSelected(value);
                        break;
                    case 'contratto':
                        self.supportModel.tipoRichiestaSelezionata = undefined;
                        self.supportModel.additionalInfo = false;
                        self.supportModel.isSpesa = false;
                        callListRequestPv();
                    default:
                        console.log('property error:', property);
                }
                self.messageCheck();
            }

            self.getDropDownRequestsPv = function () {
                var level = self.supportModel.categoriaSelezionata ? 1 : 0;

                $arcService.getDropDownRequestsPv(
                    level,
                    'RICHIESTE_POSTVENDITA',
                    self.supportModel.categoriaSelezionata,
                    true
                )
                    .then(function (response) {
                        if (!self.supportModel.categoriaSelezionata) {
                            self.supportModel.listaCategorie = response;
                        } else {
                            self.supportModel.listaTipoRichiesta = response;
                        }
                    })
                    .catch(function (error) {
                        console.log('error', error);
                    })
            }

            self.startRequestPv = function () {
                self.supportModel.isPending = true;

                $arcService.startRequestPv(
                    self.supportModel.tipoRichiestaSelezionata.type,
                    self.supportModel.tipoRichiestaSelezionata.subtype,
                    self.supportModel.message,
                    self.supportModel.contrattiSelezionati
                )
                    .then(function (response) {
                        self.supportModel.isPending = false;

                        if (response.targetWizard && response.success) {
                            var richiestePostVenditaModel = RichiestePostVendita.build({
                                id: response.idRichiesta,
                                idWf: response.idRichiesta,
                                applicationName: response.applicationName,
                                typeWf: response.type,
                                route: response.targetWizard,
                                viewIndex: response.index,
                                type: self.supportModel.tipoRichiestaSelezionata.type,
                                subtype: self.supportModel.tipoRichiestaSelezionata.subtype,
                                status: response.status,
                                metadata: {
                                    ctrRichiestaList: self.supportModel.contrattiSelezionati
                                }
                            });
                            $transactionFactory.set(richiestePostVenditaModel);
                            if (response.targetWizard == '/assistenzaTecnica') {
                                $rootScope.$broadcast("addAlert", {
                                    text: "REQUEST_PV_SUBMITTED"
                                });
                                self.supportModel.categoriaSelezionata = undefined;
                                self.supportModel.tipoRichiestaSelezionata = undefined;
                                self.supportModel.additionalInfo = false;
                                self.supportModel.message = undefined;
                                self.tipiCategorie = [];

                            } else {
                                $location.path(response.targetWizard);
                            }

                        } else if (response.success) {
                            $rootScope.$broadcast("addAlert", {
                                text: "REQUEST_PV_SUBMITTED"
                            });
                            self.supportModel.categoriaSelezionata = undefined;
                            self.supportModel.tipoRichiestaSelezionata = undefined;
                            self.supportModel.additionalInfo = false;
                            self.supportModel.message = undefined;
                            self.tipiCategorie = [];

                        } else {
                            self.supportModel.categoriaSelezionata = undefined;
                            self.supportModel.tipoRichiestaSelezionata = undefined;
                            self.supportModel.additionalInfo = false;
                            self.supportModel.isSpesa = false;
                            self.supportModel.message = undefined;
                            self.tipiCategorie = [];
                        }
                        self.supportModel.creaRichiestaEnabled = false;
                        self.supportModel.contrattiSelezionati = undefined;
                        self.supportModel.listaTipoRichiesta = undefined;
                        self.supportModel.checkSpesa.selected = false;
                        self.startRequestPractice({
                            request: true
                        })
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.supportModel.isPending = false;
                    })
            }

            self.messageCheck = function () {
                if (self.supportModel.additionalInfo) {
                    if (self.supportModel.isSpesa) {
                        if (
                            self.supportModel.contrattiSelezionati &&
                            self.supportModel.tipoRichiestaSelezionata &&
                            self.supportModel.message &&
                            self.supportModel.checkSpesa.selected
                        ) {
                            self.supportModel.creaRichiestaEnabled = true;
                        } else {
                            self.supportModel.creaRichiestaEnabled = false;
                        }
                    } else {
                        if (
                            self.supportModel.contrattiSelezionati &&
                            self.supportModel.tipoRichiestaSelezionata &&
                            self.supportModel.message
                        ) {
                            self.supportModel.creaRichiestaEnabled = true;
                        } else {
                            self.supportModel.creaRichiestaEnabled = false;
                        }
                    }
                } else if (self.supportModel.isSpesa) {
                    if (
                        self.supportModel.contrattiSelezionati &&
                        self.supportModel.tipoRichiestaSelezionata &&
                        self.supportModel.checkSpesa.selected
                    ) {
                        self.supportModel.creaRichiestaEnabled = true;
                    } else {
                        self.supportModel.creaRichiestaEnabled = false;
                    }
                } else {
                    if (
                        self.supportModel.contrattiSelezionati &&
                        self.supportModel.tipoRichiestaSelezionata
                    ) {
                        self.supportModel.creaRichiestaEnabled = true;
                    } else {
                        self.supportModel.creaRichiestaEnabled = false;
                    }
                }
            }

            self.onCheckboxChange = function (el) {
                el.selected = !el.selected;
                self.supportModel.checkSpesa = el;
                self.messageCheck();
            }

            var getListOfContract = function () {
                self.loaderListContract = true;
                $arcService.getContracts(self.filter)
                    .then(function (response) {
                        if (response.success) {
                            self.supportModel.listaContratti = response.listContratti
                        }
                        self.loaderListContract = false;
                    })
                    .catch(function (error) {
                        self.loaderListContract = false;
                    })
            }

            var callListRequestPv = function () {
                if (!self.supportModel.contrattiSelezionati.length) {
                    self.tipiCategorie = undefined;
                    self.supportModel.listaTipoRichiesta = undefined;
                    self.supportModel.additionalInfo = false;
                    return;
                }
                self.supportModel.listaTipoRichiesta = []
                self.loaderListaRichieste = true;
                $arcService.tipiRichiestaGroup(self.supportModel.contrattiSelezionati)
                    .then(function (response) {
                        if (response.success) {
                            self.tipiCategorie = Object.values(response.tipiRichiesteGroup)
                            self.tipiCategorie.forEach(function (element) {
                                element.forEach(function (tipo) {
                                    tipo.selected = true
                                    self.supportModel.listaTipoRichiesta.push(tipo)
                                })
                            })
                            if (response.disabled) {
                                self.messageTipiRichiesta = response.message
                            }
                            showTooltip()
                        }
                        self.loaderListaRichieste = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.loaderListaRichieste = false;
                    })
            }

            var popolateListOfCheckSelected = function () {

                for (var i = 0; i < self.supportModel.listaTipoRichiesta.length; i++) {
                    self.supportModel.elementSelected[i] = false;
                }
            }

            var disabledNotSelected = function (value) {

                self.tipiCategorie.forEach(function (arr) {
                    arr.forEach(function (el) {
                        if (value == el.subtypeDescr) {
                            el.selected = true;
                        } else {
                            el.selected = false;
                        }
                    })

                })

            }

            var showTooltip = function () {
                $timeout(function () {

                    self.supportModel.listaTipoRichiesta.forEach(function (element) {
                        if (element.numMaxCtr != null && element.numMaxCtr < self.supportModel.contrattiSelezionati.length) {

                            $('[data-toggle="' + element.subtype + '"]').tooltip();
                        }
                    })
                }, 500)
            }

            var showTooltip = function () {
                $timeout(function () {

                    self.supportModel.listaTipoRichiesta.forEach(function (element) {
                        if (element.numMaxCtr != null && element.numMaxCtr < self.supportModel.contrattiSelezionati.length) {

                            $('[data-toggle="' + element.subtype + '"]').tooltip();
                        }
                    })
                }, 500)
            }
        }
    })
